const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userInfo: state => state.user.userInfo,
  permission: state => state.user.permission,
  name: state => state.user.name,
  roles: state => state.user.roles,
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  attrList: state => state.attr.attrList,
  product: state => state.product.product
}
export default getters;


// WEBPACK FOOTER //
// ./src/store/getters.js